import sphLogo from '@/assets/logos/small-portguese-hotels-logo.webp';

export const SPH_LOGO = sphLogo;
export const SPH_LOGO_ALT = 'Small Portuguese Hotels';

const SPH_MENU_LINK = {
  name: 'Hotels',
  link: 'https://www.smallportuguesehotels.com/hoteis',
};

export const SPH_CHANNEL_KEYS = [
  'ec39e31b66b3616961b22c749aef1ce5',
  '39ed7b7b7dae559eb40276305db50f97',
];

export const HARDCODED_SPH_MENUS = Object.fromEntries(
  SPH_CHANNEL_KEYS.map((key) => [key, [SPH_MENU_LINK]]),
);

export const isSphChannelKey = (channelKey) =>
  SPH_CHANNEL_KEYS.includes(channelKey);
